import actions from './constants';

export const updateCurrentCollectionPermissions = (code, permissions) => ({
  type: actions.UPDATE_CURRENT_COLLECTION_PERMISSIONS,
  code,
  permissions,
});

export const fetchCollectionMembers = (category, code, assignable, filter) => ({
  type: actions.FETCH_COLLECTION_MEMBERS,
  category,
  code,
  assignable,
  filter,
});

export const updateCollectionMembersProperties = (category, code, assignable, properties) => ({
  type: actions.UPDATE_COLLECTION_MEMBERS_PROPERTIES,
  category,
  code,
  assignable,
  properties,
});

export const showShareCollection = (category, code) => ({
  type: actions.SHOW_SHARE_COLLECTION,
  category,
  code,
});

export const hideShareCollection = (category, code) => ({
  type: actions.HIDE_SHARE_COLLECTION,
  category,
  code,
});

export const showCollectionMembers = (category, code, results, resultsCount, assignable) => ({
  type: actions.SHOW_COLLECTION_MEMBERS,
  category,
  code,
  results,
  resultsCount,
  assignable,
});

export const showCollectionMembersError = (category, code, error, assignable) => ({
  type: actions.SHOW_COLLECTION_MEMBERS_ERROR,
  category,
  code,
  error,
  assignable,
});

export const updateShareCollectionProperties = (properties) => ({
  type: actions.UPDATE_SHARE_COLLECTION_PROPERTIES,
  properties,
});

export const addCollectionMembers = (category, code) => ({
  type: actions.ADD_COLLECTION_MEMBERS,
  category,
  code,
});

export const removeCollectionMember = (category, code, memberID) => ({
  type: actions.REMOVE_COLLECTION_MEMBER,
  category,
  code,
  memberID,
});

export const updateCollectionMemberPermissions = (category, code, memberID, permissions) => ({
  type: actions.UPDATE_COLLECTION_MEMBER_PERMISSIONS,
  category,
  code,
  memberID,
  permissions,
});

export const shareCollection = () => ({
  type: actions.SHARE_COLLECTION,
});

export const shareCollectionSuccess = (code, name, members, destroy) => ({
  type: actions.SHARE_COLLECTION_SUCCESS, code, name, members, destroy,
});

export const shareCollectionError = (code, name, members) => ({
  type: actions.SHARE_COLLECTION_ERROR, code, name, members,
});
